import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { LogtoProvider } from "@logto/react"
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query"
import { Toaster } from "@/components/ui/sonner"

import "./index.css"
import App from "./App.tsx"
import { ThemeProvider } from "@/components/theme-provider.tsx"
import { logtoConfig } from "@/auth/LogtoConfig"
import {
  captureMonitoringException,
  initMonitoring,
  Sentry,
} from "@/monitoring/sentry"
import { MonitoringErrorFallback } from "@/monitoring/monitoring-error-fallback"

initMonitoring()

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      captureMonitoringException(error)
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      captureMonitoringException(error)
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
})

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<MonitoringErrorFallback />}>
      <LogtoProvider config={logtoConfig}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider defaultTheme="light">
            <App />
            <Toaster position="bottom-center" />
          </ThemeProvider>
        </QueryClientProvider>
      </LogtoProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>
)
